// helpers
import { storeAnalyticsDataInLocal } from 'shared/helpers/storage/storeData';

export const saveAnalytics = () => {
  storeAnalyticsDataInLocal({ footerCategoriesLinkClicked: 1 });
};
